module.exports = __webpack_public_path__ + "static/media/station_nyarutarama9.616ac649.jpeg";